var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{attrs:{"icon":_vm.svg,"variant":_vm.variant,"font-scale":"1.2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }